import React, { useState, Fragment, useEffect } from 'react';

import { Form } from 'react-final-form';
import {
  useDataProvider,
  useRefresh,
  useNotify,
  cacheDataProviderProxy,
  required,
} from 'react-admin';
import { DialogActions, DialogContent } from '@material-ui/core';
import { useStyles } from '../modal.styles';
import { handleNumbers, getDateInputValue } from '.';
import { ReferenceInput } from '../modalForms';
import { SaveButton } from '../../../../design';
import { authGet } from '../../../../server';
export const ReportPermissionsForm = ({ handleClose }) => {
  const refresh = useRefresh();
  const classes = useStyles();
  const dataProvider = cacheDataProviderProxy(useDataProvider());
  const notify = useNotify();
  const [formData, setFormData] = useState({
    roles: [],
  });

  useEffect(() => {
    const getRoles = async () => {
      const response = await authGet([
        `/reports-roles`,
        { report_id: formData.report_id },
      ]);
      const { data } = response;
      if (data) {
        const { roles } = data;
        setFormData(f => ({ ...f, roles: roles }));
      }
    };
    if (formData.report_id !== undefined) getRoles();
  }, [formData.report_id]);
  const onSubmit = value => {
    return dataProvider
      .update('reports', {
        id: value.report_id,
        data: {
          ...value,
        },
      })
      .then(({ data }) => {
        notify('form.updated');
        handleClose();
        refresh();
      })
      .catch(error =>
        notify(
          typeof error === 'string'
            ? error
            : error.message || 'ra.notification.http_error',
          'warning',
        ),
      );
  };

  const customOnChange = async (eventOrValue, _name, type) => {
    // when using a react-admin input, onChange returns
    // the value instead of the target.
    let value = eventOrValue;
    let name = _name;
    if (typeof eventOrValue === 'object') {
      const target = eventOrValue.target;
      value = target.type === 'checkbox' ? target.checked : target.value;
      name = target.name;
    }
    if (type === 'number') {
      value = handleNumbers(value);
    }
    if (type === 'date') {
      value = getDateInputValue(value);
    }
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Fragment>
      <Form
        onSubmit={onSubmit}
        initialValues={{
          ...formData,
        }}
        render={({
          submitError,
          handleSubmit,
          submitting,
          pristine,
          values,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <ReferenceInput
                  reference='reports/list'
                  customOnChange={customOnChange}
                  name='report_id'
                  label='Report'
                  required
                  validate={required()}
                  fullWidth
                />
                <ReferenceInput
                  reference='roles/list'
                  customOnChange={customOnChange}
                  name='roles'
                  label='Roles'
                  required
                  validate={required()}
                  fullWidth
                  multiple
                />
              </DialogContent>
              <DialogActions
                className={classes.padding16}
                style={{ paddingBottom: 16 }}
              >
                <SaveButton
                  // onClick={handleClose}
                  className={classes.saveButton}
                  disabled={submitting}
                  type='submit'
                />
              </DialogActions>
            </form>
          );
        }}
      />
    </Fragment>
  );
};
